import { render, staticRenderFns } from "./ProductGraph.vue?vue&type=template&id=406f4fa4&scoped=true"
import script from "./ProductGraph.vue?vue&type=script&lang=js"
export * from "./ProductGraph.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "406f4fa4",
  null
  
)

export default component.exports